export const AccountParentFactory = () => {
    return function AccountParent() {
        this.uuid = null;
        this.username = null;
    };
};
